import { USER_UPGRADE_CLEAR } from "@/constants/constants";
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  // GET LIST PREPAID
  GET_LIST_MOVEMENT_PREPAID_BEGINS:
    "LIST_MOVEMENT_PREPAID/GET_LIST_MOVEMENT_PREPAID_BEGINS",
  GET_LIST_MOVEMENT_PREPAID_SUCCESS:
    "LIST_MOVEMENT_PREPAID/GET_LIST_MOVEMENT_PREPAID_SUCCESS",
  GET_LIST_MOVEMENT_PREPAID_FAILURE:
    "LIST_MOVEMENT_PREPAID/GET_LIST_MOVEMENT_PREPAID_FAILURE",
  /* ACCUMULATED ACTIONS */
  GET_ACCUMULATED_USAGE_PREPAID_BEGINS: "GET_ACCUMULATED_USAGE_PREPAID_BEGINS",
  GET_ACCUMULATED_USAGE_PREPAID_SUCCESS:
    "GET_ACCUMULATED_USAGE_PREPAID_SUCCESS",
  GET_ACCUMULATED_USAGE_PREPAID_FAILURE:
    "GET_ACCUMULATED_USAGE_PREPAID_FAILURE",
  /* DETAILS ACTIONS */
  GET_DETAILS_USAGE_PREPAID_BEGINS: "GET_DETAILS_USAGE_PREPAID_BEGINS",
  GET_DETAILS_USAGE_PREPAID_SUCCESS: "GET_DETAILS_USAGE_PREPAID_SUCCESS",
  GET_DETAILS_USAGE_PREPAID_FAILURE: "GET_DETAILS_USAGE_PREPAID_FAILURE",
  /* BALANCE */
  GET_BALANCE_PREPAID_BEGINS: "GET_BALANCE_PREPAID_BEGINS",
  GET_BALANCE_PREPAID_SUCCESS: "GET_BALANCE_PREPAID_SUCCESS",
  GET_BALANCE_PREPAID_FAILURE: "GET_BALANCE_PREPAID_FAILURE",
  /* RECHARGE PREPAID */
  RECHARGE_PREPAID_BEGINS: "RECHARGE_PREPAID_BEGINS",
  RECHARGE_PREPAID_SUCCESS: "RECHARGE_PREPAID_SUCCESS",
  RECHARGE_PREPAID_FAILURE: "RECHARGE_PREPAID_FAILURE",
  RESET_RECHARGE_PREPAID: "RESET_RECHARGE_PREPAID",
  /* PREPAID BONUS BY ID */
  GET_BONUS_PREPAID_BY_ID: "PRODUCTS/GET_BONUS_PREPAID_BY_ID",
  GET_BONUS_PREPAID_BY_ID_SUCCESS: "PRODUCTS/GET_BONUS_PREPAID_BY_ID_SUCCESS",
  GET_BONUS_PREPAID_BY_ID_FAILURE: "PRODUCTS/GET_BONUS_PREPAID_BY_ID_FAILURE",
  // GET LIST TARIFF
  GET_LIST_TARIFF_PREPAID_BEGINS:
    "LIST_TARIFF_PREPAID/GET_LIST_TARIFF_PREPAID_BEGINS",
  GET_LIST_TARIFF_PREPAID_SUCCESS:
    "LIST_TARIFF_PREPAID/GET_LIST_TARIFF_PREPAID_SUCCESS",
  GET_LIST_TARIFF_PREPAID_FAILURE:
    "LIST_TARIFF_PREPAID/GET_LIST_TARIFF_PREPAID_FAILURE",
  /* DETALLE TARIFA */
  GET_TARIF_DETAIL_PREPAID_BEGINS:
    "TARIF_DETAIL_PREPAID/GET_TARIF_DETAIL_PREPAID_BEGINS",
  GET_TARIF_DETAIL_PREPAID_SUCCESS:
    "TARIF_DETAIL_PREPAID/GET_TARIF_DETAIL_PREPAID_SUCCESS",
  GET_TARIF_DETAIL_PREPAID_FAILURE:
    "TARIF_DETAIL_PREPAID/GET_TARIF_DETAIL_PREPAID_FAILURE",
  /*  SPECIFIC BONUS PREPAID BY ID */
  GET_SPECIFIC_BONUS_PREPAID_BY_ID: "PRODUCTS/GET_SPECIFIC_BONUS_PREPAID_BY_ID",
  GET_SPECIFIC_BONUS_PREPAID_BY_ID_SUCCESS:
    "PRODUCTS/GET_SPECIFIC_BONUS_PREPAID_BY_ID_SUCCESS",
  GET_SPECIFIC_BONUS_PREPAID_BY_ID_FAILURE:
    "PRODUCTS/GET_SPECIFIC_BONUS_PREPAID_BY_ID_FAILURE",
};

export const actions = {
  getListMovementPrepaid: (data) => ({
    type: types.GET_LIST_MOVEMENT_PREPAID_BEGINS,
    data,
  }),
  successGetListMovementData: (data) => ({
    type: types.GET_LIST_MOVEMENT_PREPAID_SUCCESS,
    payload: data,
  }),
  failureGetListMovementData: (error) => ({
    type: types.GET_LIST_MOVEMENT_PREPAID_FAILURE,
    payload: error,
  }),
  // GET ACCUMULATED USAGE PREPRAID
  getAccumulatedUsagesPrepaid: () => ({
    type: types.GET_ACCUMULATED_USAGE_PREPAID_BEGINS,
  }),
  successGetAccumulatedUsagesPrepaid: (data) => ({
    type: types.GET_ACCUMULATED_USAGE_PREPAID_SUCCESS,
    payload: data,
  }),
  failureAccumulateUsagesPrepaid: (error) => ({
    type: types.GET_ACCUMULATED_USAGE_PREPAID_FAILURE,
    payload: error,
  }),
  /* DETAILS */
  getDetailsUsagesPrepaid: (productId) => ({
    type: types.GET_DETAILS_USAGE_PREPAID_BEGINS,
    payload: productId,
  }),
  successGetDetailsUsagesPrepaid: (data) => ({
    type: types.GET_DETAILS_USAGE_PREPAID_SUCCESS,
    payload: data,
  }),
  failureDetailsUsagesPrepaid: (error) => ({
    type: types.GET_DETAILS_USAGE_PREPAID_FAILURE,
    payload: error,
  }),
  /* BALANCE */
  getBalancePrepaid: (productId) => ({
    type: types.GET_BALANCE_PREPAID_BEGINS,
    payload: productId,
  }),
  successGetBalancePrepaid: (data) => ({
    type: types.GET_BALANCE_PREPAID_SUCCESS,
    payload: data,
  }),
  failureGetBalancePrepaid: () => ({ type: types.GET_BALANCE_PREPAID_FAILURE }),

  // RECHARGE
  getRechargePrepaid: (data) => ({ type: types.RECHARGE_PREPAID_BEGINS, data }),
  successRechargeData: (data) => ({
    type: types.RECHARGE_PREPAID_SUCCESS,
    payload: data,
  }),
  failureRechargeData: (error) => ({
    type: types.RECHARGE_PREPAID_FAILURE,
    payload: error,
  }),
  resetRechargePrepaid: () => ({
    type: types.RESET_RECHARGE_PREPAID,
  }),
  // BONUS
  getBonusPrepaidById: () => ({
    type: types.GET_BONUS_PREPAID_BY_ID,
  }),
  getBonusPrepaidByIdSuccess: (data) => ({
    type: types.GET_BONUS_PREPAID_BY_ID_SUCCESS,
    payload: data,
  }),
  getBonusPrepaidByIdFailure: (error) => ({
    type: types.GET_BONUS_PREPAID_BY_ID_FAILURE,
    payload: error,
  }),
  // LIST TARIFF
  getListTariffPrepaid: () => ({
    type: types.GET_LIST_TARIFF_PREPAID_BEGINS,
  }),
  successGetListTariffData: (data) => ({
    type: types.GET_LIST_TARIFF_PREPAID_SUCCESS,
    payload: data,
  }),
  failureGetListTariffData: (error) => ({
    type: types.GET_LIST_TARIFF_PREPAID_FAILURE,
    payload: error,
  }),
  // DETAIL TARIF
  getTarifDetailsPrepaid: (params) => ({
    type: types.GET_TARIF_DETAIL_PREPAID_BEGINS,
    payload: params,
  }),
  successGetTarifDetailData: (data) => ({
    type: types.GET_TARIF_DETAIL_PREPAID_SUCCESS,
    payload: data,
  }),
  failureGetTarifDetailData: (error) => ({
    type: types.GET_TARIF_DETAIL_PREPAID_FAILURE,
    payload: error,
  }),
  // SPECIFIC BONUS DETAIL
  getSpecificBonusPrepaidById: (bonuId) => ({
    type: types.GET_SPECIFIC_BONUS_PREPAID_BY_ID,
    bonuId,
  }),
  getSpecificBonusPrepaidByIdSuccess: (data) => ({
    type: types.GET_SPECIFIC_BONUS_PREPAID_BY_ID_SUCCESS,
    payload: data,
  }),
  getSpecificBonusPrepaidByIdFailure: (error) => ({
    type: types.GET_SPECIFIC_BONUS_PREPAID_BY_ID_FAILURE,
    payload: error,
  }),
};

export const initialState = {
  // GET LIST PREPAID
  listMovementPrepaidData: [],
  listMovementPrepaidDataFetching: false,
  listMovementPrepaidDataError: null,

  accumulatedUsagesPrepaid: null,
  accumulatedUsagesPrepaidFetching: false,
  allAccumulatedUsagesPrepaidFetched: false,
  accumulatedUsagesPrepaidError: null,
  /* DETAILS */
  detailsUsagesPrepaid: [],
  detailsUsagesPrepaidFetching: false,
  detailsUsagesPrepaidError: null,
  /* BALANCE */
  balancePrepaid: null,
  balancePrepaidFetching: false,
  balancePrepaidError: false,

  // RECHARGE PREPAID
  recharge_prepaid: {
    rechargePrepaidData: null,
    rechargePrepaidDataFetching: false,
    rechargePrepaidDataError: null,
  },
  /* BONUS */
  bonusPrepaidByIdInfo: [],
  bonusPrepaidByIdFetching: false,
  bonusPrepaidByIdError: false,
  // GET LIST TARIFF PREPAID
  list_tariff_prepaid: {
    listTariffPrepaidData: {},
    listTariffPrepaidDataFetching: false,
    listTariffPrepaidDataError: null,
  },
  // GET TARIF DETAIL
  tarifDetailPrepaidData: null,
  tarifDetailPrepaidDataFetching: false,
  tarifDetailPrepaidDataError: null,
  /* SPECIFIC BONUS */
  specificBonusPrepaidByIdInfo: null,
  specificBonusPrepaidByIdFetching: false,
  specificBonusPrepaidByIdError: false,
};
function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { prepaid } = payload;
      return {
        ...state,
        ...prepaid,
      };
    }
    case USER_UPGRADE_CLEAR:
      return initialState;
    // GET LIST PREPAID
    case types.GET_LIST_MOVEMENT_PREPAID_BEGINS: {
      return {
        ...state,
        listMovementPrepaidDataFetching: true,
        listMovementPrepaidDataError: null,
      };
    }
    case types.GET_LIST_MOVEMENT_PREPAID_SUCCESS: {
      return {
        ...state,
        listMovementPrepaidData: payload,
        listMovementPrepaidDataFetching: false,
        listMovementPrepaidDataError: false,
      };
    }
    case types.GET_LIST_MOVEMENT_PREPAID_FAILURE: {
      return {
        ...state,
        listMovementPrepaidDataError: payload,
        listMovementPrepaidDataFetching: false,
      };
    }
    // GET ACCUMULATED USAGE
    case types.GET_ACCUMULATED_USAGE_PREPAID_BEGINS: {
      return {
        ...state,
        accumulatedUsagesPrepaidFetching: true,
        accumulatedUsagesPrepaidError: false,
      };
    }
    case types.GET_ACCUMULATED_USAGE_PREPAID_SUCCESS: {
      return {
        ...state,
        accumulatedUsagesPrepaid: payload,
        allAccumulatedUsagesPrepaidFetched: true,
        accumulatedUsagesPrepaidFetching: false,
        accumulatedUsagesPrepaidError: false,
      };
    }
    case types.GET_ACCUMULATED_USAGE_PREPAID_FAILURE: {
      return {
        ...state,
        accumulatedUsagesPrepaidFetching: false,
        accumulatedUsagesPrepaidError: payload,
      };
    }
    // GET DETAILS USAGE
    case types.GET_DETAILS_USAGE_PREPAID_BEGINS: {
      return {
        ...state,
        detailsUsagesPrepaidFetching: true,
      };
    }
    case types.GET_DETAILS_USAGE_PREPAID_SUCCESS: {
      return {
        ...state,
        detailsUsagesPrepaid: payload,
        detailsUsagesPrepaidFetching: false,
        detailsUsagesPrepaidError: false,
      };
    }
    case types.GET_DETAILS_USAGE_PREPAID_FAILURE: {
      return {
        ...state,
        detailsUsagesPrepaidFetching: false,
        detailsUsagesPrepaidError: payload,
      };
    }
    /* BALANCE */
    case types.GET_BALANCE_PREPAID_BEGINS: {
      return {
        ...state,
        balancePrepaidFetching: true,
      };
    }
    case types.GET_BALANCE_PREPAID_SUCCESS: {
      return {
        ...state,
        balancePrepaid: payload,
        balancePrepaidFetching: false,
        balancePrepaidError: false,
      };
    }
    case types.GET_BALANCE_PREPAID_FAILURE: {
      return {
        ...state,
        balancePrepaidFetching: false,
        balancePrepaidError: true,
      };
    }
    // RECHARGE PREPAID
    case types.RECHARGE_PREPAID_BEGINS: {
      return {
        ...state,
        recharge_prepaid: {
          rechargePrepaidDataFetching: true,
          rechargePrepaidDataError: null,
        },
      };
    }
    case types.RECHARGE_PREPAID_SUCCESS: {
      const data = payload;
      return {
        ...state,
        recharge_prepaid: {
          rechargePrepaidData: data,
          rechargePrepaidDataFetching: false,
          rechargePrepaidDataError: false,
        },
      };
    }
    case types.RECHARGE_PREPAID_FAILURE: {
      return {
        ...state,
        recharge_prepaid: {
          rechargePrepaidDataError: true,
          rechargePrepaidDataFetching: false,
        },
      };
    }
    case types.RESET_RECHARGE_PREPAID: {
      return {
        ...state,
        recharge_prepaid: {
          rechargePrepaidData: null,
          rechargePrepaidDataFetching: false,
          rechargePrepaidDataError: null,
        },
      };
    }
    /* GET BONUS LIST */
    case types.GET_BONUS_PREPAID_BY_ID: {
      return {
        ...state,
        bonusPrepaidByIdFetching: true,
      };
    }
    case types.GET_BONUS_PREPAID_BY_ID_SUCCESS: {
      return {
        ...state,
        bonusPrepaidByIdFetching: false,
        bonusPrepaidByIdInfo: payload.splice(0, 1000),
        bonusPrepaidByIdError: false,
      };
    }
    case types.GET_BONUS_PREPAID_BY_ID_FAILURE: {
      return {
        ...state,
        bonusPrepaidByIdFetching: false,
        bonusPrepaidByIdError: true,
      };
    }
    // GET LIST PREPAID
    case types.GET_LIST_TARIFF_PREPAID_BEGINS: {
      return {
        ...state,
        list_tariff_prepaid: {
          listTariffPrepaidDataFetching: true,
          listTariffPrepaidDataError: null,
        },
      };
    }
    case types.GET_LIST_TARIFF_PREPAID_SUCCESS: {
      const data = payload;
      return {
        ...state,
        list_tariff_prepaid: {
          listTariffPrepaidData: data,
          listTariffPrepaidDataFetching: false,
          listTariffPrepaidDataError: false,
        },
      };
    }
    case types.GET_LIST_TARIFF_PREPAID_FAILURE: {
      return {
        ...state,
        list_tariff_prepaid: {
          listTariffPrepaidDataError: payload,
          listTariffPrepaidDataFetching: false,
        },
      };
    }
    // GET TARIF DETAIL
    case types.GET_TARIF_DETAIL_PREPAID_BEGINS: {
      return {
        ...state,
        tarifDetailPrepaidDataFetching: true,
        tarifDetailPrepaidDataError: null,
      };
    }
    case types.GET_TARIF_DETAIL_PREPAID_SUCCESS: {
      const tarif = payload;

      return {
        ...state,
        tarifDetailPrepaidData: tarif,
        tarifDetailPrepaidDataFetching: false,
        tarifDetailPrepaidDataError: false,
      };
    }
    case types.GET_TARIF_DETAIL_PREPAID_FAILURE: {
      return {
        ...state,
        tarifDetailPrepaidDataError: payload,
        tarifDetailPrepaidDataFetching: false,
      };
    }
    /* GET SPECIFIC BONUS */
    case types.GET_SPECIFIC_BONUS_PREPAID_BY_ID: {
      return {
        ...state,
        specificBonusPrepaidByIdFetching: true,
      };
    }
    case types.GET_SPECIFIC_BONUS_PREPAID_BY_ID_SUCCESS: {
      return {
        ...state,
        specificBonusPrepaidByIdFetching: false,
        specificBonusPrepaidByIdInfo: payload,
        specificBonusPrepaidByIdError: false,
      };
    }
    case types.GET_SPECIFIC_BONUS_PREPAID_BY_ID_FAILURE: {
      return {
        ...state,
        specificBonusPrepaidByIdFetching: false,
        specificBonusPrepaidByIdError: true,
      };
    }
    default:
      return state;
  }
}

export default reducer;
